<template>
    <ModelEditLayout
        :indexRoute="$route('admin::profile.edit')"
        :updateRoute="$route('admin::profile.update')"
        :modelNameSingular="__('admin::users.profile')"
        :modelNamePlural="__('admin::users.my_profile')"
        :form="form"
        :name="form.name"
    >

        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.email')" :error="errors.email">
            <Input name="email" type="email" :has-error="exists(errors.email)" v-model="form.email" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.password')" :error="errors.password">
            <Input name="password" type="password" :has-error="exists(errors.password)" v-model="form.password" :required="false" />
        </FormGroup>

    </ModelEditLayout>
</template>

<script>
import ModelEditLayout from "@/Layouts/ModelEditLayout";
import FormGroup from "@/Components/FormGroup";
import Input from "@/Components/Input";

export default {
    components: {Input, FormGroup, ModelEditLayout},
    props: {
        errors: Object,
        user: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                name: this.user.name,
                email: this.user.email,
                password: '',
            })
        }
    },
}
</script>
